import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, GlobalStyles } from "@mui/material";
// Os mesmos icones que o InovacaoData antigo usava na faixa de numeros --
// importados de verdade em vez de redesenhados em SVG para nao arriscar um
// glifo "parecido, mas nao igual".
import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MainHeader from "../../components/MainHeader";
import Rodape from "../../components/Rodape";
import HeaderSecti from "../../components/HeaderSecti";
import { store } from "../../store";

// Imagens que a landing já usava. O componente MapaInovacao NÃO é reaproveitado
// aqui: ele renderiza uma seção completa com título, texto e botão próprios, o
// que duplicava tudo que já existe nesta seção. Usamos só o mapa dele.
// Versões APARADAS dos recortes originais. Nos arquivos de origem a figura
// ocupava uma fração do canvas (no lab_person, 1182x1959 dentro de 3000x3000 —
// 26% da área; o resto era margem transparente), então com object-fit a pessoa
// saía minúscula no card. Geradas com `convert -trim +repage -resize x900`,
// que de quebra levou cada arquivo de ~3 MB para menos de 750 KB.
// ATENCAO ao nome dos arquivos de origem: 'oxetechtrilhas_person.png' NAO e a
// figura do OxeTrilhas -- e o rapaz do OXEDIN (o SobreProgramas antigo importa
// esse mesmo arquivo como `fotoDin`). A figura do OxeTrilhas e a
// 'oxetrilhas_garota.png'. Por isso os recortes daqui levam o nome do programa a
// que a pessoa pertence de verdade, e nao o nome do arquivo de origem.
import heroPessoa from "../../assets/person_banner_recortado.png";
import sobrePessoa from "../../assets/person_sobre_recortado.png";
import fotoLab from "../../assets/oxetechlab_person_recortado.png";
import fotoWork from "../../assets/oxetechwork_person_recortado.png";
import fotoOxedin from "../../assets/oxedin_person_recortado.png";
import fotoTrilhas from "../../assets/oxetrilhas_garota_recortado.png";
import logoOxedin from "../../assets/logo_oxeDIN.png";
import logoLab from "../../assets/LogoLab.png";
import logoWork from "../../assets/logoWork.png";
import logoTrilhas from "../../assets/LogoTrilhas.png";
import figuraMapa from "../../assets/Mapa.png";

// Landing redesenhada a partir do artboard "Landing Page Oxetech" (Claude
// Design). O artboard desenha barra Secti, navegação e rodapé por dentro; aqui
// eles continuam sendo HeaderSecti / MainHeader / Rodape — os mesmos das outras
// telas — para a navegação não divergir entre páginas. O que mudou é o corpo:
// herói, faixa de números, programas com filtro, "Inovação e capacitação",
// Mapa da Inovação e chamada final.
const LP = {
  laranja: "#D2551D",
  laranjaEscuro: "#B8460F",
  azul: "#2C5FA8",
  amarelo: "#B8862A",
  vermelho: "#C63C33",
  tinta: "#1F1E1C",
  texto: "#4A453E",
  textoSuave: "#6B655D",
  apagado: "#8C8478",
  linha: "#EDE4D6",
  bordaSuave: "#E2DACD",
  creme: "#FFF9EF",
  cremeForte: "#FDF3E2",
  azulClaro: "#EAF1FA",
};

const FONTE = "'Poppins', system-ui, sans-serif";

const PROGRAMAS = [
  {
    nome: "OXETECH lab",
    titulo: "Um lab bem perto de você",
    tags: ["estudo"],
    cor: LP.laranja,
    texto:
      "Cursos gratuitos e presenciais em espaços modernos, incentivando o aprendizado em ciência e tecnologia em todo o Estado.",
    imagem: fotoLab,
    logo: logoLab,
    fundoImagem: "#FBE0D0", // laranja do Lab
    para: "/oxetechlab",
  },
  {
    nome: "OXETECH work",
    titulo: "Encontre vagas de trabalho",
    tags: ["trabalho"],
    cor: LP.azul,
    texto:
      "Qualificação intensiva e bolsas de estudo conectando capacitação e emprego, em parceria com universidades e empresas locais.",
    imagem: fotoWork,
    logo: logoWork,
    fundoImagem: "#DCE8F7", // azul do Work
    para: "/oxetechwork",
  },
  {
    nome: "OXEDIN",
    titulo: "Conectando talentos e empresas",
    tags: ["trabalho", "empresa"],
    cor: LP.amarelo,
    texto:
      "Empresas publicam vagas, encontram profissionais formados pelo OxeTech Lab e acompanham o progresso dos alunos.",
    imagem: fotoOxedin,
    logo: logoOxedin,
    fundoImagem: "#E4E3F7", // azul arroxeado do OxeDin
    para: "/oxetechwork",
  },
  {
    nome: "OXE trilhas",
    titulo: "Aprenda a programar de qualquer lugar",
    tags: ["estudo"],
    cor: LP.vermelho,
    texto:
      "Plataforma de capacitação gratuita e on-line com cursos de programação, gestão de projetos e cibersegurança.",
    imagem: fotoTrilhas,
    logo: logoTrilhas,
    fundoImagem: "#F8DDD9", // vermelho do Trilhas
    para: "/oxetrilhas",
  },
];

const FILTROS = [
  { id: "todos", rotulo: "Todos" },
  { id: "estudo", rotulo: "Quero estudar" },
  { id: "trabalho", rotulo: "Quero trabalhar" },
  { id: "empresa", rotulo: "Sou empresa" },
];

// Números vindos do artboard — NÃO são consultados no banco. Ficam reunidos
// aqui para poderem ser conferidos ou ligados a um endpoint real sem caçar
// valor solto no meio do JSX.
const METAS = [
  { alvo: 200, sufixo: "+", rotulo: "Cursos realizados", icone: SchoolIcon },
  { alvo: 10, sufixo: " mil+", rotulo: "Estudantes formados", icone: SchoolIcon },
  { alvo: 425, sufixo: "+", rotulo: "Vagas de emprego", icone: WorkIcon },
  { alvo: 300, sufixo: "+", rotulo: "Empregos efetivados", icone: EmojiEventsIcon },
];

const PUBLICOS = [
  {
    fundo: LP.azulClaro,
    cor: LP.azul,
    texto: "Estudantes do ensino médio e superior",
    icone: (
      <>
        <path d="M12 4l9 4.5-9 4.5-9-4.5z" />
        <path d="M6.5 11v4.5c0 1.5 2.6 2.8 5.5 2.8s5.5-1.3 5.5-2.8V11" />
      </>
    ),
  },
  {
    fundo: "#FCF1DA",
    cor: LP.amarelo,
    texto: "Professores e profissionais de educação",
    icone: (
      <>
        <rect x="3" y="4.5" width="18" height="12" rx="2" />
        <path d="M8 20h8M12 16.5V20" />
      </>
    ),
  },
  {
    fundo: "#FBE7DB",
    cor: LP.laranja,
    texto: "Startups e empresas de base tecnológica",
    icone: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M9 7V5h6v2" />
      </>
    ),
  },
];

// ---------------------------------------------------------------------------
// Animações do artboard. O design usa `animation-timeline: view()` para os
// blocos que revelam ao rolar, mas isso é Chrome recente — este projeto roda em
// react-scripts 4 e precisa funcionar em navegador mais velho, então a revelação
// por scroll é feita com IntersectionObserver (mesmo mecanismo que já anima os
// números). Durações e curvas são as do arquivo de design.
// ---------------------------------------------------------------------------
const CURVA = "cubic-bezier(.2,.7,.3,1)";

const KEYFRAMES = {
  "@keyframes riseIn": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "none" },
  },
  "@keyframes fadeIn": { from: { opacity: 0 }, to: { opacity: 1 } },
  "@keyframes floatUp": {
    "0%, 100%": { transform: "translateY(0)" },
    "50%": { transform: "translateY(-14px)" },
  },
  "@keyframes floatDown": {
    "0%, 100%": { transform: "translateY(0)" },
    "50%": { transform: "translateY(11px)" },
  },
  "@keyframes breathe": {
    "0%, 100%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.035)" },
  },
};

// Quem pediu menos movimento no sistema não recebe animação nenhuma — é a mesma
// regra que o design declara em @media (prefers-reduced-motion: reduce).
const semMovimento = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Entrada com atraso, para o herói montar em cascata em vez de tudo de uma vez.
const entrada = (duracao, atraso = 0) =>
  semMovimento()
    ? {}
    : { animation: `riseIn ${duracao}s ${CURVA} both`, animationDelay: `${atraso}s` };

const flutuar = (nome, duracao, atraso = 0) =>
  semMovimento()
    ? {}
    : { animation: `${nome} ${duracao}s ease-in-out infinite`, animationDelay: `${atraso}s` };

// Revela o conteúdo quando ele entra na tela (uma vez só).
function useRevelar(margem = "0px 0px -12% 0px") {
  const ref = useRef(null);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const alvo = ref.current;
    if (!alvo || typeof IntersectionObserver === "undefined" || semMovimento()) {
      setVisivel(true);
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entradas) => {
        if (entradas.some((e) => e.isIntersecting)) {
          setVisivel(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: margem }
    );
    obs.observe(alvo);
    return () => obs.disconnect();
  }, [margem]);

  return [ref, visivel];
}

// Envolve um bloco e o revela ao entrar na tela.
function Revelar({ children, duracao = 0.8, atraso = 0, sx = {} }) {
  const [ref, visivel] = useRevelar();
  return (
    <Box
      ref={ref}
      sx={{
        ...sx,
        opacity: visivel ? 1 : 0,
        ...(visivel ? entrada(duracao, atraso) : {}),
      }}
    >
      {children}
    </Box>
  );
}

const Seta = ({ tamanho = 17 }) => (
  <svg
    width={tamanho}
    height={tamanho}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M5 12h13M12 5.5l6.5 6.5-6.5 6.5" />
  </svg>
);

const Faixa = React.forwardRef(function Faixa(
  { children, fundo = "#fff", py = { xs: 6, md: 11 }, id },
  ref
) {
  return (
    <Box
      id={id}
      ref={ref}
      component="section"
      sx={{
        display: "flex",
        justifyContent: "center",
        background: fundo,
        py,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 1280, px: { xs: 2.5, md: 5 }, position: "relative" }}>
        {children}
      </Box>
    </Box>
  );
});

const Etiqueta = ({ children, cor = LP.azul }) => (
  <Typography
    component="span"
    sx={{
      fontFamily: FONTE,
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: ".18em",
      textTransform: "uppercase",
      color: cor,
    }}
  >
    {children}
  </Typography>
);

// Conta de 0 até o alvo quando a faixa entra na tela. Respeita
// prefers-reduced-motion: quem pediu menos movimento vê o número final direto.
function useContagem(metas, ativo) {
  const [valores, setValores] = useState(() => metas.map(() => 0));
  const jaRodou = useRef(false);

  useEffect(() => {
    if (!ativo || jaRodou.current) return undefined;
    jaRodou.current = true;

    const semMovimento =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (semMovimento) {
      setValores(metas.map((m) => m.alvo));
      return undefined;
    }

    const inicio = performance.now();
    const duracao = 1400;
    let raf;
    const passo = (agora) => {
      const t = Math.min(1, (agora - inicio) / duracao);
      const suave = 1 - Math.pow(1 - t, 3);
      setValores(metas.map((m) => Math.round(m.alvo * suave)));
      if (t < 1) raf = requestAnimationFrame(passo);
    };
    raf = requestAnimationFrame(passo);
    return () => raf && cancelAnimationFrame(raf);
  }, [ativo, metas]);

  return valores;
}

function Main() {
  const { signed } = store.getState().auth;

  // Quem ja esta logado nao tem o que fazer em /select-cadastro (a tela de
  // escolher entre cadastro de aluno e de empresa). As duas chamadas para acao
  // da landing -- "Comece agora" no heroi e "Conecte-se agora" no rodape --
  // mandam essa pessoa direto para o painel. /dashboard serve aluno e empresa.
  const destinoCTA = signed ? "/dashboard" : "/select-cadastro";

  const [filtro, setFiltro] = useState("todos");
  const [statsVisivel, setStatsVisivel] = useState(false);
  const statsRef = useRef(null);
  const inovacaoRef = useRef(null);
  const numeros = useContagem(METAS, statsVisivel);

  // Mantido do comportamento anterior: o MainHeader chama isto para rolar até
  // a seção de inovação.
  const scrollToInovacao = () => {
    if (inovacaoRef.current) {
      inovacaoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const alvo = statsRef.current;
    if (!alvo || typeof IntersectionObserver === "undefined") {
      setStatsVisivel(true);
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entradas) => {
        if (entradas.some((e) => e.isIntersecting)) {
          setStatsVisivel(true);
          obs.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    obs.observe(alvo);
    return () => obs.disconnect();
  }, []);

  const programasVisiveis =
    filtro === "todos" ? PROGRAMAS : PROGRAMAS.filter((p) => p.tags.includes(filtro));

  return (
    <>
      <GlobalStyles styles={KEYFRAMES} />

      {!signed && <HeaderSecti />}
      {!signed && <MainHeader scrollToInovacao={scrollToInovacao} />}

      {/* Herói */}
      <Faixa py={{ xs: 6, md: "84px" }}>
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            left: -160,
            top: 120,
            width: 340,
            height: 340,
            borderRadius: "50%",
            background: LP.cremeForte,
            display: { xs: "none", md: "block" },
          }}
        />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(auto-fit, minmax(min(420px, 100%), 1fr))" },
            gap: { xs: 5, md: "56px 72px" },
            alignItems: "center",
            position: "relative",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box sx={entrada(0.6)}>
              <Etiqueta>Bem-vindo ao OxeTech</Etiqueta>
            </Box>
            <Typography
              component="h1"
              sx={{
                fontFamily: FONTE,
                fontSize: { xs: 40, sm: 52, md: 66 },
                lineHeight: 1.03,
                fontWeight: 700,
                letterSpacing: "-.03em",
                color: LP.laranja,
                textWrap: "pretty",
                ...entrada(0.7, 0.08),
              }}
            >
              Conectando Alagoas ao futuro
            </Typography>
            <Typography
              sx={{
                fontFamily: FONTE,
                maxWidth: 530,
                fontSize: { xs: 16, md: 19 },
                lineHeight: 1.62,
                color: LP.texto,
                textWrap: "pretty",
                ...entrada(0.7, 0.18),
              }}
            >
              Ciência, tecnologia e inovação ao seu alcance. Capacitação gratuita, networking e
              vagas de trabalho para impulsionar a economia de Alagoas.
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1, flexWrap: "wrap", ...entrada(0.7, 0.28) }}>
              <Button
                component={Link}
                to={destinoCTA}
                endIcon={<Seta />}
                sx={{
                  height: 56,
                  px: 4,
                  borderRadius: "999px",
                  background: LP.laranja,
                  color: "#fff",
                  fontFamily: FONTE,
                  fontSize: 16,
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0 12px 26px rgba(210,85,29,.28)",
                  "&:hover": { background: LP.laranjaEscuro },
                }}
              >
                Comece agora
              </Button>
              <Button
                href="#programas"
                sx={{
                  height: 56,
                  px: "30px",
                  borderRadius: "999px",
                  border: `1.5px solid ${LP.bordaSuave}`,
                  color: "#3B3833",
                  fontFamily: FONTE,
                  fontSize: 16,
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": { borderColor: LP.laranja, color: LP.laranja, background: "transparent" },
                }}
              >
                Conhecer os programas
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                mt: 0.75,
                fontFamily: FONTE,
                fontSize: 14,
                color: LP.apagado,
                ...(semMovimento() ? {} : { animation: "fadeIn .8s ease-out both", animationDelay: ".42s" }),
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={LP.azul} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M5 12.5l4.5 4.5L19 7" />
              </svg>
              100% gratuito para alagoanos · inscrições abertas o ano todo
            </Box>
          </Box>

          {/* person_banner.png é um RECORTE com fundo transparente (2500x2500,
              figura centrada com muita área vazia). Por isso nada de arco nem
              'cover': eles recortavam o vazio e o resultado virava um borrão.
              Um único círculo creme atrás + a figura em 'contain' por cima. */}
          <Box sx={{ position: "relative", display: { xs: "none", md: "flex" }, alignItems: "center", justifyContent: "center", minHeight: 520 }}>
            <Box
              aria-hidden
              sx={{
                position: "absolute",
                width: 460,
                height: 460,
                borderRadius: "50%",
                background: LP.cremeForte,
                ...flutuar("breathe", 9),
              }}
            />
            <Box
              aria-hidden
              sx={{ position: "absolute", right: 24, top: 40, width: 84, height: 84, borderRadius: "84px 0 0 84px", background: "#E8B93C", ...flutuar("floatUp", 7) }}
            />
            <Box
              aria-hidden
              sx={{ position: "absolute", left: 18, bottom: 92, width: 68, height: 68, borderRadius: "0 68px 68px 0", background: LP.vermelho, ...flutuar("floatDown", 8, 0.6) }}
            />
            <Box
              component="img"
              src={heroPessoa}
              alt="Estudante do OxeTech"
              sx={{
                position: "relative",
                width: "100%",
                maxWidth: 420,
                height: 520,
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Faixa>

      {/* Números */}
      <Box ref={statsRef} component="section" sx={{ display: "flex", justifyContent: "center", background: LP.azul, py: "38px" }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: 1280,
            px: { xs: 2.5, md: 5 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(auto-fit, minmax(min(220px, 100%), 1fr))" },
            gap: 3,
          }}
        >
          {METAS.map((m, i) => (
            <Box key={m.rotulo} sx={{ display: "flex", alignItems: "center", gap: { xs: 1.5, md: 2 }, pl: 2.5, borderLeft: "2px solid rgba(255,255,255,.25)" }}>
              {/* Icone em branco translucido, e nao no laranja do design antigo:
                  aqui a faixa e azul, e o laranja sobre azul perde contraste. */}
              <Box
                component={m.icone}
                aria-hidden
                sx={{ flex: "none", fontSize: { xs: 34, md: 44 }, color: "rgba(255,255,255,.85)" }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
                <Typography component="span" sx={{ fontFamily: FONTE, fontSize: { xs: 30, md: 38 }, fontWeight: 700, color: "#fff", letterSpacing: "-.02em", fontVariantNumeric: "tabular-nums" }}>
                  {numeros[i]}
                  {m.sufixo}
                </Typography>
                <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 14, color: "rgba(234,241,250,.82)" }}>
                  {m.rotulo}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Programas */}
      <Faixa id="programas">
        <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <Revelar duracao={0.8} sx={{ display: "flex", alignItems: { md: "flex-end" }, justifyContent: "space-between", gap: 5, flexDirection: { xs: "column", md: "row" } }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, maxWidth: 640 }}>
              <Etiqueta>Programas</Etiqueta>
              <Typography component="h2" sx={{ fontFamily: FONTE, fontSize: { xs: 30, md: 46 }, lineHeight: 1.08, fontWeight: 700, letterSpacing: "-.025em", color: LP.tinta, textWrap: "pretty" }}>
                Prepare-se. Conecte-se. Transforme-se.
              </Typography>
            </Box>
            <Typography sx={{ fontFamily: FONTE, maxWidth: 400, fontSize: 16, lineHeight: 1.62, color: LP.textoSuave }}>
              Quatro frentes que levam o alagoano do primeiro curso à contratação. Escolha por onde
              começar.
            </Typography>
          </Revelar>

          <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap" }}>
            {FILTROS.map((f) => {
              const ativo = filtro === f.id;
              return (
                <Button
                  key={f.id}
                  onClick={() => setFiltro(f.id)}
                  sx={{
                    height: 42,
                    px: "18px",
                    borderRadius: "999px",
                    fontFamily: FONTE,
                    fontSize: 13.5,
                    fontWeight: 600,
                    textTransform: "none",
                    background: ativo ? LP.tinta : "#fff",
                    color: ativo ? "#fff" : LP.texto,
                    border: `1.5px solid ${ativo ? LP.tinta : LP.bordaSuave}`,
                    "&:hover": { background: ativo ? LP.tinta : LP.creme },
                  }}
                >
                  {f.rotulo}
                </Button>
              );
            })}
          </Box>

          {/* Grid de 4 colunas FIXAS (não auto-fit): com auto-fit, filtrar para
              2 programas esticava os cards e a foto era recortada de forma
              diferente em cada estado. Colunas fixas mantêm todo card do mesmo
              tamanho, com ou sem filtro. */}
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }, gap: 3, alignItems: "stretch" }}>
            {programasVisiveis.map((p, i) => (
              <Box
                key={p.nome}
                sx={{
                  // Escalonado por índice: os quatro cards entram em sequência,
                  // não todos no mesmo instante.
                  ...entrada(0.55, 0.06 * i),
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "18px",
                  overflow: "hidden",
                  background: "#fff",
                  border: `1px solid ${LP.linha}`,
                  transition: "transform .2s, box-shadow .2s",
                  "&:hover": { transform: "translateY(-4px)", boxShadow: "0 18px 36px rgba(70,45,20,.12)" },
                }}
              >
                {/* Altura fixa + objectFit contain: as fotos são recortes de
                    pessoa, então 'cover' cortava cabeça/rosto assim que o card
                    mudava de largura. Com 'contain' a pessoa aparece inteira e
                    os cards ficam idênticos entre si. */}
                <Box
                  sx={{
                    position: "relative",
                    height: 230,
                    flex: "none",
                    // Fundo na cor do próprio programa (e não mais um creme
                    // único): é o que identifica o caminho de relance, antes
                    // mesmo de ler o título. Tons claros de propósito — a
                    // pessoa recortada e a logo por cima precisam continuar
                    // legíveis sobre ele.
                    background: p.fundoImagem || LP.cremeForte,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="img"
                    src={p.imagem}
                    alt={p.nome}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      // TODAS centralizadas — encostar à direita para escapar da
                      // etiqueta deixava um vazio à esquerda em cada card e o
                      // logo do OXEDIN (centrado) destoava dos outros três.
                      // A etiqueta agora é evitada por espaço no topo, não por
                      // deslocamento lateral.
                      objectPosition: "center bottom",
                      pt: "52px",
                      display: "block",
                    }}
                  />
                  {/* Logo da marca no canto SUPERIOR DIREITO, grande. Substitui
                      a etiqueta de texto: a marca de verdade identifica melhor o
                      programa (e o vermelho do OxeTrilhas, o azul do Work etc.
                      já vêm da própria arte, sem eu recolorir nada). */}
                  {p.logo && (
                    <Box
                      component="img"
                      src={p.logo}
                      alt={p.nome}
                      sx={{
                        position: "absolute",
                        right: 16,
                        top: 14,
                        height: 30,
                        width: "auto",
                        maxWidth: "62%",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: "26px 24px 28px", flex: 1 }}>
                  <Typography component="h3" sx={{ fontFamily: FONTE, fontSize: 19, fontWeight: 700, letterSpacing: "-.01em", color: LP.tinta, textWrap: "pretty" }}>
                    {p.titulo}
                  </Typography>
                  <Typography sx={{ fontFamily: FONTE, flex: 1, fontSize: 14.5, lineHeight: 1.6, color: LP.textoSuave, textWrap: "pretty" }}>
                    {p.texto}
                  </Typography>
                  <Box
                    component={Link}
                    to={p.para}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      fontFamily: FONTE,
                      fontSize: 14.5,
                      fontWeight: 600,
                      color: LP.laranja,
                      textDecoration: "none",
                      "&:hover": { color: "#A83D0C" },
                    }}
                  >
                    Descubra <Seta tamanho={15} />
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Faixa>

      {/* Inovação e capacitação — alvo do scroll do MainHeader.
          A figura é a person_sobre.png, a MESMA que o InovacaoData antigo usava
          nesta seção: é a foto dela, não a do herói. Antes daqui reaproveitar a
          do topo a página repetia a mesma pessoa duas vezes (e a menina não
          aparecia em lugar nenhum). Sem espelhamento — ela já olha para o texto,
          e o mirror só existia para disfarçar a repetição. */}
      <Faixa ref={inovacaoRef} fundo={LP.creme} py={{ xs: 6, md: "88px" }}>
        <Revelar duracao={0.85} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(auto-fit, minmax(min(400px, 100%), 1fr))" }, gap: { xs: 5, md: "56px 80px" }, alignItems: "center" }}>
          <Box sx={{ position: "relative", display: { xs: "none", md: "flex" }, alignItems: "center", justifyContent: "center", minHeight: 460 }}>
            <Box
              aria-hidden
              sx={{ position: "absolute", width: 400, height: 400, borderRadius: "50%", background: LP.cremeForte, ...flutuar("breathe", 9) }}
            />
            <Box
              component="img"
              src={sobrePessoa}
              alt="Estudante do OxeTech"
              sx={{
                position: "relative",
                width: "100%",
                maxWidth: 400,
                height: 460,
                objectFit: "contain",
                display: "block",
              }}
            />
            <Box sx={{ position: "absolute", left: 0, bottom: 56, display: "flex", alignItems: "center", gap: 1.25, px: 2.5, py: 1.6, borderRadius: "14px", background: LP.laranja, color: "#fff", fontFamily: FONTE, fontSize: 14, fontWeight: 600, boxShadow: "0 12px 26px rgba(210,85,29,.3)", ...flutuar("floatUp", 6.5) }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <rect x="3" y="6.5" width="12.5" height="11" rx="2" />
                <path d="M15.5 11l5-2.6v7.2l-5-2.6z" />
              </svg>
              Aulas ao vivo
            </Box>
            <Box sx={{ position: "absolute", right: 0, top: 48, display: "flex", alignItems: "center", gap: 1.25, px: 2.5, py: 1.6, borderRadius: "14px", background: LP.azul, color: "#fff", fontFamily: FONTE, fontSize: 14, fontWeight: 600, boxShadow: "0 12px 26px rgba(44,95,168,.3)", ...flutuar("floatDown", 7.5, 0.4) }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <circle cx="9" cy="8.5" r="3.2" />
                <path d="M3.5 19c.9-3 3-4.5 5.5-4.5s4.6 1.5 5.5 4.5" />
                <path d="M16.5 6.5a3 3 0 010 5.6" />
              </svg>
              Contatos e network
            </Box>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.75 }}>
            <Etiqueta>Sobre o programa</Etiqueta>
            <Typography component="h2" sx={{ fontFamily: FONTE, fontSize: { xs: 30, md: 48 }, lineHeight: 1.06, fontWeight: 700, letterSpacing: "-.025em", color: LP.laranja, textWrap: "pretty" }}>
              Inovação e capacitação
            </Typography>
            <Typography sx={{ fontFamily: FONTE, maxWidth: 580, fontSize: { xs: 15.5, md: 17 }, lineHeight: 1.68, color: LP.texto, textWrap: "pretty" }}>
              O OxeTech promove a capacitação técnica e profissional dos alagoanos, incentivando o
              empreendedorismo e atraindo investimentos para o estado — com um espaço moderno para o
              desenvolvimento de conhecimento.
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2, mt: 1 }}>
              {PUBLICOS.map((pub) => (
                <Box key={pub.texto} sx={{ display: "flex", flexDirection: "column", gap: 1.25, p: "22px 20px", borderRadius: "16px", background: "#fff", border: `1px solid ${LP.linha}` }}>
                  <Box component="span" sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: "11px", background: pub.fundo, color: pub.cor }}>
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                      {pub.icone}
                    </svg>
                  </Box>
                  <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 15, fontWeight: 600, color: LP.tinta, lineHeight: 1.35 }}>
                    {pub.texto}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Revelar>
      </Faixa>

      {/* Mapa da Inovação — o mapa segue sendo o componente que já existe; o
          design refez só a moldura e o texto ao lado. */}
      <Faixa id="mapa" py={{ xs: 6, md: "88px" }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(auto-fit, minmax(min(380px, 100%), 1fr))" }, gap: { xs: 5, md: "48px 72px" }, alignItems: "center" }}>
          <Revelar duracao={0.85} sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Etiqueta>Ecossistema</Etiqueta>
            <Typography component="h2" sx={{ fontFamily: FONTE, fontSize: { xs: 30, md: 44 }, lineHeight: 1.08, fontWeight: 700, letterSpacing: "-.025em", color: LP.laranja }}>
              Nosso Mapa da Inovação
            </Typography>
            <Typography sx={{ fontFamily: FONTE, fontSize: 16.5, lineHeight: 1.66, color: LP.texto, textWrap: "pretty" }}>
              Um mapa interativo que reúne profissionais, empresas e instituições de ciência e
              tecnologia de Alagoas. Conheça localização, descrição e perfil de cada iniciativa em um
              único lugar.
            </Typography>
            <Box sx={{ display: "flex", gap: { xs: 3, md: "34px" }, py: 2.5, borderTop: `1px solid ${LP.linha}`, borderBottom: `1px solid ${LP.linha}`, flexWrap: "wrap" }}>
              {[
                { n: "102", r: "municípios" },
                { n: "340+", r: "iniciativas mapeadas" },
                { n: "18", r: "laboratórios OxeTech" },
              ].map((d) => (
                <Box key={d.r} sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 28, fontWeight: 700, color: LP.tinta }}>
                    {d.n}
                  </Typography>
                  <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 13.5, color: LP.apagado }}>
                    {d.r}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Revelar>

          <Box
            sx={{
              borderRadius: "24px",
              border: `1px solid #F0E6D6`,
              background: LP.creme,
              height: 460,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            <Box
              component="img"
              src={figuraMapa}
              alt="Mapa da Inovação de Alagoas"
              sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block" }}
            />
          </Box>
        </Box>
      </Faixa>

      {/* Chamada final */}
      <Faixa fundo={LP.laranja} py={{ xs: 6, md: "78px" }}>
        <Revelar duracao={0.8} sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: { xs: 4, md: "32px 60px" } }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 14, fontWeight: 500, color: "rgba(255,246,236,.85)" }}>
              Encontre cursos e vagas
            </Typography>
            <Typography component="h2" sx={{ fontFamily: FONTE, fontSize: { xs: 28, md: 44 }, lineHeight: 1.1, fontWeight: 700, letterSpacing: "-.025em", color: "#fff", textWrap: "pretty" }}>
              Vamos construir juntos o futuro?
            </Typography>
            <Typography component="span" sx={{ fontFamily: FONTE, fontSize: 16, color: "rgba(255,246,236,.85)" }}>
              Inicie sua jornada no mercado de inovação em Alagoas.
            </Typography>
          </Box>
          <Button
            component={Link}
            to={destinoCTA}
            endIcon={<Seta tamanho={18} />}
            sx={{
              flex: "none",
              height: 60,
              px: "38px",
              borderRadius: "999px",
              background: "#fff",
              color: LP.laranja,
              fontFamily: FONTE,
              fontSize: 17,
              fontWeight: 700,
              textTransform: "none",
              "&:hover": { background: "#FFF1E4", color: LP.laranjaEscuro },
            }}
          >
            Conecte-se agora
          </Button>
        </Revelar>
      </Faixa>

      <Rodape />
    </>
  );
}

export default Main;
